/* eslint-disable no-undef */
/* eslint-disable class-methods-use-this */
if (!customElements.get("global-fancy-box")) {
  class GlobalFancyBox extends HTMLElement {
    connectedCallback() {
      this.id = this.dataset.id;

      if (!this.id || typeof Fancybox === 'undefined') {
        return;
      }

      Fancybox.bind(`[data-fancybox='${this.id}']`);
    }
  }

  customElements.define("global-fancy-box", GlobalFancyBox);
}
